import { useConfiguration } from "@src/hooks/query/useConfiguration";
import { useMemo } from "react";
import usePageLang from "./usePageLang";
import {
  GATSBY_CONF_HOME_DISPLAY_OTHER_CONTRY,
  GATSBY_INTL_DEFAULT_LANG,
} from "@src/utils/constants";
import { EAuthentificationStep } from "@src/components/feedback/AuthenticationContent/EAuthentificationStep";

const useNavigationUrlFactory = () => {
  const { getConfiguration: c } = useConfiguration();
  const currentLang = usePageLang();

  const locale = currentLang;
  // TODO: define other routes generator
  const routes = useMemo(
    () => ({
      //     /* picture: () =>
      //       "<%= model +'-'+ id_picture +'-'+ suffix +'/'+ rewrite +'.'+ extension %>",

      //     gui: () => "gui",

      home: () => {
        return !GATSBY_CONF_HOME_DISPLAY_OTHER_CONTRY &&
          locale === GATSBY_INTL_DEFAULT_LANG
          ? "/"
          : `/${locale}/`;
      },

      //     logout: () => "<%= c('_LOGOUT_REWRITE_') %>",

      accountDashboard: () =>
        `/${locale}/${c("_ACCOUNT_BASE_URL_", "my-account")}`,
      accountLink: () =>
        `/${locale}/${c("_ACCOUNT_BASE_URL_", "my-account")}/${c(
          "_ACCOUNT_LOYALTY_REWRITE_",
          ""
        )}`,
      accountOrders: () =>
        `/${locale}/${c("_ACCOUNT_BASE_URL_", "my-account")}/${c(
          "_ACCOUNT_ORDERS_REWRITE_",
          "orders-history"
        )}`,
      accountPage: (account_rewrite: string) =>
        `/${locale}/${c(
          "_ACCOUNT_BASE_URL_",
          "my-account"
        )}/${account_rewrite}`,

      //     reorder: () => "<%= c('_PAGE_REORDER_BASE_URL_') %>",

      //     cart: () => "<%= c('_CHECKOUT_BASE_URL_') %>/<%= c('_CART_BASE_URL_') %>",
      checkoutOpc: (rewrite: string = "") =>
        `/${locale}/${c("_CHECKOUT_BASE_URL_", "checkout")}${
          !!rewrite ? "/" + rewrite : ""
        }`,
      checkout: () =>
        routes.checkoutOpc(c("_CHECKOUT_PAYMENT_REWRITE_", "paiement")),
      // checkoutCrossSelling: () =>
      //   routes.checkoutOpc(
      //     c("_CHECKOUT_CROSS_SELLING_REWRITE_", "cross-selling")
      //   ),
      //     product: () =>
      //       "<%= c('_CATEGORY_BASE_URL_') +'/'+ category_link_rewrite %>/<%= product_link_rewrite %>-<%= id_product %>",

      authentification: (step?: EAuthentificationStep) =>
        `/${locale}/${c("_AUTHENTIFICATION_BASE_URL_", "authentification")}${
          step ? "?step=" + step : ""
        }`,
      supportCenter: () =>
        `/${locale}/${c("_SUPPORT_CENTER_BASE_URL_", "service-client")}`,
      supportCenterResource: (type: string, id: string) =>
        `/${locale}/${c(
          "_SUPPORT_CENTER_BASE_URL_",
          "service-client"
        )}/${type}-${id}`,
      supportCenterSearch: (query: string) =>
        `/${locale}/${c(
          "_SUPPORT_CENTER_BASE_URL_",
          "service-client"
        )}/search?query=${query}`,
      //     supportCenterSection: () =>
      //       "<%= c('_SUPPORT_CENTER_BASE_URL_') +'/'+ section_rewrite %>",
      //     recruitment: () => "<%= c('_RECRUITMENT_URL_') %>",
      //  */
      // widgetGroup: (params: { widget_group_rewrite: string }) => params.widget_group_rewrite,

      stores: () => `/${locale}/${c("_STORES_BASE_URL_", "")}/`,
      // storeLocatorSearch: (params: { search: string }) => `${c("_STORES_BASE_URL_", "")}/${params.search}`,
      //  storeLocatorState: () => "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_STATE_PREFIX_', 'r') %>/<%= state %>",
      // storeLocatorPosition: () => "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_POSITION_PREFIX_','pos') %>/<%= lat %>_<%= lng %>",
      // storeLocatorBounds: () => "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_BOUNDS_PREFIX_','bounds') %>/<%= bounds %>",
      // storeLocatorPostcode: () => "<%= c('_STORES_BASE_URL_') %>/<%= city %>/<%= postcode %>",
      // storeLocatorShop: () => "<%= c('_STORES_BASE_URL_') %>/<%= c('_STORELOC_SHOP_PREFIX_', 's') %>/<%= shop %>",
      // store: () => "<%= c('_STORE_BASE_URL_') +'/'+ store_rewrite %>",

      // kei: () => "<%= c('_KEI_URL_') %>",
      // carte2017: () => "<%= c('_CARTE_2017_URL_') %>",

      // newsHome: () => "<%= c('_PAGE_NEWS_BASE_URL_') %>",
      // newsFlag: () => "<%= c('_PAGE_NEWS_BASE_URL_') %>/flag/<%= url_rewrite %>",
      // newsSingle: () => "<%= c('_PAGE_NEWS_BASE_URL_') %>/<%= url_rewrite %>",

      // category: () => "<%= c('_CATEGORY_BASE_URL_') +'/'+ category_link_rewrite %>",
      allCategories: () =>
        `/${locale}/${c("_ALL_CATEGORIES_BASE_URL_", "all-categories")}`,

      // "webapps-action": () => "webapps-action/<%= action %>/",
      // "webapps-action-product": () => "webapps-action/<%= action %>/<%= id_product %>/<%= option %>",
      // "webapps-action-redirect-category": () => "webapps-action/redirect/category",

      // video: () => "USER/video/exports/<%= id_video %>.<%= size %>.<%= type %>.<%= format %>",
      // videoHD: () => "USER/video/HD/<%= id_video %>.mp4",

      // tc_vars: () => "FRONTOFFICE/ajax/tc_vars.js.php?contentType=json&",
      // tc_url: () => "<%= c('_TAGCOMMANDERURLFOOTER_') %>",
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locale, c]
  );

  // const getUrl = <T extends keyof typeof routes, K extends typeof routes>(
  //   route: T,
  //   params: ArgumentTypes<K[T]>[0]
  // ) => {
  //   return `/${intl.locale}/${routes[route](params)}`;
  // };
  return routes;
};

export default useNavigationUrlFactory;
